import { Component } from 'preact'
import { BaseFilterSelectorBuilderData, FilterSelectorProps } from './interfaces'
import { extractRenderPropsChildren } from '../../../libs/renderProps'
import Icon from '@insided/deprecated-preact-components/assets'
import { FilterSelector } from '@insided/deprecated-control/overview/filters/FiltersMenu'
import InputGroup from '@insided/deprecated-control/ui-components/InputGroup'

export interface AdvancedTextInputFilterCondition {
  id: string
  name: string
  value: string
  showInput: boolean
}

export interface AdvancedTextInputFilterProps extends FilterSelectorProps<State> {
  conditions: AdvancedTextInputFilterCondition[]
}

interface State {
  data: string
  condition: string
  showInput: boolean
}

interface BuilderData extends BaseFilterSelectorBuilderData {
  conditions: AdvancedTextInputFilterCondition[]
}

class AdvancedTextInputFilter extends Component<AdvancedTextInputFilterProps, State> {
  static create = ({ conditions, ...config }: BuilderData): FilterSelector => ({
    component: this,
    type: 'filter',
    getPillDisplayValue: ({ data, condition, showInput }: State): string => {
      const rawCondition = conditions.find(c => c.value === condition)
      const value = showInput ? ` ${data}` : ''

      return `${rawCondition?.name}${value}`
    },
    conditions,
    ...config
  })

  constructor(props: AdvancedTextInputFilterProps) {
    super(props)

    const { conditions: [firstCondition] } = this.props

    this.state = {
      data: props.selectedFilterItems?.data ?? '',
      condition: props.selectedFilterItems?.condition ?? firstCondition.value ?? '',
      showInput: props.selectedFilterItems?.showInput ?? firstCondition.showInput ?? false
    }
  }

  setCondition = (condition: string, showInput: boolean) => {
    this.setState({ condition, showInput })
  }

  render() {
    const { name, children, conditions } = this.props
    const { data, condition: currentCondition, showInput } = this.state
    const inputClassName = 'qa-search-box-filter'

    return (
      <div>
        <div className='overview__filters-box-content'>
          {conditions.map(condition => {
            const checked = currentCondition === condition.value

            return (
              <div key={condition.id}>
                <InputGroup
                  inline
                  qaClasses={`qa-filter-input-${condition.value}`}
                  key={condition.id}
                  id={condition.id}
                  name={name}
                  value={condition.value}
                  title={condition.name}
                  type='radio'
                  formGroupClasses='overview__filters-box-filter'
                  checked={checked}
                  onChange={() => this.setCondition(condition.value, condition.showInput)}
                />
                {checked && condition.showInput && (
                  <div className='control-search-box'>
                    <div>
                      <Icon size={16} icon='search' />
                      <input
                        className={inputClassName}
                        type='text'
                        value={data}
                        placeholder={condition.name}
                        maxLength={500}
                        onInput={(e) => this.setState({ data: (e.target as HTMLInputElement).value })}
                      />
                      {data && (
                        <Icon
                          icon='close'
                          size={16}
                          onClick={() => this.setState({ data: '' })}
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            )
          })}
        </div>
        {extractRenderPropsChildren(children)({
          data: {
            data,
            showInput,
            condition: currentCondition
          },
          isApplyButtonDisabled: !currentCondition || (showInput && data.length === 0)
        })}
      </div>
    )
  }
}

export default AdvancedTextInputFilter
